/* istanbul ignore file */
import React from 'react';

import { DelayedSuspense } from '@lumapps/lumx-suspense/components/DelayedSuspense';

import { PostPickerDialogProps } from '../../types';

const PostPickerDialogLazy = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'posts-picker' */
            './PostPickerDialog'
        ),
);

const PostPickerDialog: React.FC<PostPickerDialogProps> = (props) => {
    const { isOpen } = props;

    return (
        <DelayedSuspense isDialog shouldLoad={isOpen}>
            {(setShouldMount) => <PostPickerDialogLazy onVisibilityChange={setShouldMount} {...props} />}
        </DelayedSuspense>
    );
};

export { PostPickerDialog };
